export default __webpack_public_path__ + "static/media/faq.2e57865d.svg";